<template>
  <div id="app">
    <transition :name='transitionName'>
      <keep-alive
        :exclude="['detailstheme','playVideo','login','chat','privacyPolicy','termsOfService','moneyRecharge','recharge','modifyAddress','articleLabel']">
        <router-view @loading="loading" @closeLoading="closeLoading" class="child-view"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  import Wait from '@/components/base/wait'

  export default {
    components: {
      Wait
    },
    data () {
      return {
        transitionName: ''
      }
    },
    methods: {
      loading (waitMsg) {
        this.waitMsg = waitMsg
        this.waiting = true
      },
      closeLoading () {
        this.waiting = false
      }
    },
    beforeRouteUpdate (to, from, next) {
      let isBack = this.$router.isBack
      if (isBack) {
        this.transitionName = 'slide-right'
      } else {
        this.transitionName = 'slide-left'
      }
      this.$router.isBack = false
      next()
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/sass/index.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue